@let connected = websocketService.connectionStatus$ | async;
<ion-toast [isOpen]="!connected" message="Connecting..." color="medium" swipeGesture="vertical" position="top"></ion-toast>
<ion-modal class="age-verification-modal" [isOpen]="shouldShowAgeVerification()" [backdropDismiss]="false" [canDismiss]="canDismissAgeVerification">
	<ng-template>
		<section class="age-verification">
			<h2>Age Verification</h2>
			<p>You must be 18 years or older to use this site.</p>
			<p class="age-verification__question">Are you 18 or older?</p>

			<div class="age-verification__actions">
				<button type="button" class="age-verification__yes" (click)="confirmAgeVerification()">Yes</button>
				<button type="button" class="age-verification__no" (click)="rejectAgeVerification()">No</button>
			</div>

			@if (isAgeVerificationRejected) {
				<p class="age-verification__error">Access is restricted to users aged 18 or older.</p>
			}
		</section>
	</ng-template>
</ion-modal>
<ion-router-outlet></ion-router-outlet>
